module.exports = global["$"] = require("-!C:\\OpenServer\\domains\\bsmp\\node_modules\\expose-loader\\index.js?jQuery!C:\\OpenServer\\domains\\bsmp\\node_modules\\jquery\\dist\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 0
// module chunks = 0